import { Injectable, OnDestroy } from '@angular/core';

import { fuseConfig } from 'app/fuse-config';
import { FuseConfig } from '@fuse/types';
import { HttpClient } from '@angular/common/http';
import { Subject, BehaviorSubject, Subscription, Observable } from 'rxjs';
import { Resolve } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { timer } from 'rxjs';


@Injectable()
export class CompanyService implements Resolve<any> {
    public _unsubscribeAll: Subject<any>;
    public _fuseConfig: FuseConfig;

    timer: Observable<number>;
    timerSubscription: Subscription;

    searchText: string;

    faq: any;
    activeCompany = { id: null, name: null, chat_token: null };
    onFaqChanged: BehaviorSubject<any>;
    onCompanyChanged: Subject<any>;

    /**
     * Constructor
     *
     * @param {HttpClient} _httpClient
     */
    constructor(
        public _httpClient: HttpClient,
    ) {
        this._fuseConfig = fuseConfig;
        this._unsubscribeAll = new Subject();
        this.onFaqChanged = new BehaviorSubject({});
        this.onCompanyChanged = new Subject();

    }

    /**
     * Resolver
     *
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(): Observable<any> | Promise<any> | any {
        return new Promise<void>((resolve, reject) => {
            Promise.all([
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getCompanies(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this._fuseConfig.api.url + '/portal/employee/company/listing')
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        resolve(response);
                    }, reject);
        });
    }

    getActiveCompany(): Promise<any> {
        const company = JSON.parse(localStorage.getItem('company'));
        return new Promise((resolve, reject) => {
            this._httpClient.get(this._fuseConfig.api.url + '/portal/employee/company/listing')
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        if ((!company || company === 'undefined')) {
                            this.activeCompany = { id: response['data'][0].id, name: response['data'][0].name, chat_token: response['data'][0].chat_token };
                            resolve(this.activeCompany);
                        }
                        else {
                            let companyExists = false;
                            response['data'].forEach((comp) => {
                                if (comp.id === company.id) {
                                    companyExists = true;
                                }
                            });
                            if (companyExists) {
                                this.activeCompany = company;
                                resolve(this.activeCompany);
                            }
                            else {
                                this.activeCompany = { id: response['data'][0].id, name: response['data'][0].name, chat_token: response['data'][0].chat_token };
                                resolve(this.activeCompany);
                            }
                        }
                    }, reject);

        });
    }

    setActiveCompany(company): void {
        this.activeCompany = company;
        localStorage.setItem('company', JSON.stringify(company));
        this.onCompanyChanged.next(company);
    }


}
